angular.module('eStories.audiobook', [

    /*Book Details Module*/

    'eStories.catalog.model',
    'eStories.library.model',
    'eStories.compnt.audiobookReview',
    'eStories.compnt.carousel'
])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('eStories.navbars.audiobook', {
                url: 'audiobook/:audiobookId',
                views: {
                    'mainView@': {
                        controller: 'AudiobookCtrl as audiobookCtrl',
                        templateUrl: 'store/audiobook/audiobook.tmpl.html'
                    }
                }
            })
            .state('eStories.navbars.audiobookFull', {
                url: 'audiobook/:audiobookId/:audiobookAuthors/:audiobookTitle',
                views: {
                    'mainView@': {
                        controller: 'AudiobookCtrl as audiobookCtrl',
                        templateUrl: 'store/audiobook/audiobook.tmpl.html'
                    }
                }
            })
            .state('eStories.navbars.audiobookRetailOffer', {
                url: 'audiobookRetailOffer/:audiobookId',
                views: {
                    'mainView@': {
                        controller: 'AudiobookCtrl as audiobookCtrl',
                        templateUrl: 'store/audiobook/audiobook.tmpl.html'
                    }
                }
            })
            .state('eStories.navbars.audiobookRetailOfferFull', {
                url: 'audiobookRetailOffer/:audiobookId/:audiobookAuthors/:audiobookTitle',
                views: {
                    'mainView@': {
                        controller: 'AudiobookCtrl as audiobookCtrl',
                        templateUrl: 'store/audiobook/audiobook.tmpl.html'
                    }
                }
            })
            .state('eStories.navbars.esbn', {
                url: 'esbn/:providerAudiobookId',
                views: {
                    'mainView@': {
                        controller: 'EsbnCtrl as esbnCtrl',
                        templateUrl: '<div></div>'
                    }
                }
            });
    }])

    .controller('EsbnCtrl', [
        '$stateParams', 'CatalogModel', '$location', '$scope',
        function ($stateParams, CatalogModel, $location, $scope) {
            var providerAudiobookId = $stateParams.providerAudiobookId;
            if (!providerAudiobookId) {
                return;
            }

            CatalogModel.getAudiobookByProviderId(providerAudiobookId).then((response) => {
                if (!response || response.responseStatus !== 'SUCCESS') {
                    return;
                }

                console.log("Redirecting");
                $location.path('/audiobook/' + response.audiobook.id);
                safeApply($scope);
            })
        }]
    )
    .controller('AudiobookCtrl', [
        'CatalogModel',
        '$stateParams',
        '$state',
        'ModalsModel',
        'AccountModel',
        'PagingModel',
        'LibraryModel',
        'LL',
        '$filter',
        '$rootScope',
        '$scope',
        '$controller',
        'PlayerModel',
        'ReviewModel',
        'GoogleModel',
        '$aria',
        'SeoModel',
        'GA',
        '$location',

        function (CatalogModel, $stateParams, $state, ModalsModel, AccountModel, PagingModel, LibraryModel, LL, $filter,
                  $rootScope, $scope, $controller, PlayerModel, ReviewModel, GoogleModel, $aria, SeoModel, GA, $location) {

            var audiobookCtrl = this;
            var purchaseCtrl = $controller('PurchaseCtrl', {$scope: $scope});
            angular.extend(this, purchaseCtrl);

            GA.trackPageView($location.path());

            audiobookCtrl.modal = ModalsModel;
            audiobookCtrl.account = AccountModel;

            audiobookCtrl.audiobookIsFree = function (audiobook) {
                if (audiobook != null) {
                    for (var i = 0; i < audiobook.productList.length; i++) {
                        if (audiobook.productList[i].purchaseType == 'RETAIL') {
                            if (audiobook.productList[i].nonMemberPrice == 0) {
                                audiobookCtrl.account.isFreemium = true;
                                return true;
                            } else {
                                audiobookCtrl.account.isFreemium = false;
                                return false;
                            }
                        }
                    }
                }
            };

            function isUnabridged(abridged) {
                return abridged ? 'Abridged' : 'Unabridged';
            }

            /*Extracting bookId from url*/
            var audiobookId = $stateParams.audiobookId;

            audiobookCtrl.isRetailOfferState = function () {
                return $state.current.name.indexOf("RetailOffer") > -1;
            };

            if (isMobile.iOS() && !audiobookCtrl.isRetailOfferState()) {
                document.location.href = 'estoriesapp://audiobook/' + audiobookId;
            }

            audiobookCtrl.getBackgroundStyle = function (url) {
                return getCoverStyleBackground(url);
            };

            audiobookCtrl.signUpOrConfirmTrial = function () {
                AccountModel.isFreemium = true;
                AccountModel.signUpOrConfirmTrial();
            };

            audiobookCtrl.audiobookCharDescriptionLimit = 1100;

            audiobookCtrl.showMoreLink = function () {
                return this.audiobookDescriptionLength > this.audiobookCharDescriptionLimit;
            };

            audiobookCtrl.checkProductList = function (productListArray) {
                for (var i = 0; i < productListArray.length; i++) {
                    if (productListArray[i].purchaseType == 'CREDIT') {
                        audiobookCtrl.creditPackage = productListArray[i];
                    } else {
                        audiobookCtrl.retailPackage = productListArray[i];
                    }
                }
            };

            audiobookCtrl.audiobookHasCreditProduct = function () {
                return audiobookCtrl.getProductByGroup('CREDIT', audiobookCtrl.audiobook);
            };

            audiobookCtrl.checkIfLibraryAudiobookHasProgress = function (libraryAudiobook) {
                if (!libraryAudiobook.progress) {
                    libraryAudiobook.progress = {
                        chapter: {
                            id: libraryAudiobook.audiobook.chapterList[0].id,
                            chapterNumber: libraryAudiobook.audiobook.chapterList[0].chapterNumber,
                            duration: libraryAudiobook.audiobook.chapterList[0].duration
                        },
                        position: 0
                    };
                }
                libraryAudiobook.totalRuntime = PlayerModel.getAudiobookTotalRuntime(libraryAudiobook.audiobook.chapterList);
            };

            audiobookCtrl.getAudiobookFeaturedTag = function () {
                if (!audiobookCtrl.audiobook) {
                    return false;
                } else {
                    var onSale = audiobookCtrl.audiobook.onSale === true;
                    var bestSeller = audiobookCtrl.audiobook.timesBestsellerDate;
                    var featuredTag = "";
                    var theSpaceBetween = '';
                    if (onSale && bestSeller) {
                        theSpaceBetween = '&nbsp;&nbsp;|&nbsp;&nbsp;';
                    }
                    if (onSale) {
                        featuredTag += "ON SALE";
                    }
                    if (bestSeller) {
                        featuredTag += theSpaceBetween + "BEST SELLER";
                    }
                    return featuredTag;
                }
            };

            audiobookCtrl.tagBrowsedBookLlEvent = function (audiobookObj) {
                var tagObj = LL.convertAudiobookToLocalyticsObject(audiobookObj);
                fbq('track', 'ViewContent', {
                    content_type: 'product',
                    content_category: tagObj['Genre'] ? tagObj['Genre'][0] : null,
                    content_ids: [tagObj['Book ID']],
                    content_name: tagObj['Title']
                });
                LL.tagEvent('Browsed Book', tagObj);
            };

            audiobookCtrl.initAudiobookDetails = async () => {
                const audiobookDetails = await CatalogModel.getAudiobookDetails(audiobookId);
                if (audiobookDetails.responseStatus !== 'SUCCESS') {
                    return;
                }
                audiobookCtrl.audiobook = audiobookDetails.audiobook;

                GoogleModel.dynamicRemarketing("offerdetail", audiobookCtrl.audiobook);

                audiobookCtrl.tagBrowsedBookLlEvent(audiobookDetails.audiobook);
                audiobookCtrl.audiobookRuntime = audiobookCtrl.audiobook.runtime.toString().toHHMMSS();
                audiobookCtrl.audiobookAbridged = isUnabridged(audiobookCtrl.audiobook.abridged);
                audiobookCtrl.authorList = audiobookCtrl.audiobook.authorList;
                audiobookCtrl.narratorList = audiobookCtrl.audiobook.narratorList;
                audiobookCtrl.bestSeller = audiobookCtrl.audiobook.timesBestsellerDate;
                audiobookCtrl.onSale = audiobookCtrl.audiobook.onSale;
                audiobookCtrl.streetDate = getFullDate(audiobookCtrl.audiobook.streetDate);
                audiobookCtrl.audiobookDescriptionLength = $filter('removeHtmlTags')(audiobookCtrl.audiobook.description).length;
                audiobookCtrl.cropDescription = audiobookCtrl.audiobookDescriptionLength > 800;
                audiobookCtrl.checkProductList(audiobookDetails.audiobook.productList);

                SeoModel.applyBookDetailsMetaTags(audiobookDetails.audiobook);

                if (audiobookDetails.audiobook.libraryAudiobookId != null) {
                    LibraryModel.getLibraryAudiobook(audiobookDetails.audiobook.libraryAudiobookId).then((response) => {
                        if (response.responseStatus !== 'SUCCESS') {
                            return;
                        }

                        audiobookCtrl.libraryAudiobook = response.libraryAudiobook;
                        audiobookCtrl.checkIfLibraryAudiobookHasProgress(audiobookCtrl.libraryAudiobook);
                        audiobookCtrl.purchaseDate = getStringDate(response.libraryAudiobook.creationDate);
                    });
                }

                /*More by Author*/
                if (!audiobookCtrl.authorList[0]) {
                    return;
                }
                CatalogModel.getAllAudiobooks({authorId: audiobookCtrl.authorList[0].id},
                    PagingModel.preparePagination(1, 4), audiobookId).then((response) => {
                    if (response != null && response.responseStatus == 'SUCCESS') {
                        audiobookCtrl.moreByAuthorList = response.audiobookList;
                    }
                });

                /*More by Narrator*/
                CatalogModel.getAllAudiobooks({narratorId: audiobookCtrl.narratorList[0].id},
                    PagingModel.preparePagination(1, 4), audiobookId).then((response) => {
                    if (response != null && response.responseStatus == 'SUCCESS') {
                        audiobookCtrl.moreByNarratorList = response.audiobookList;
                    }
                });

                /*Similar Titles*/
                const response = await CatalogModel.getSimilar(audiobookId, PagingModel.preparePagination(1, 6));
                if (response != null && response.responseStatus == 'SUCCESS') {
                    audiobookCtrl.similarList = response.audiobookList;
                }
            };

            audiobookCtrl.initAudiobookReviews = async () => {
                const response = await CatalogModel.getAudiobookReviews(audiobookId);
                if (response.responseStatus !== 'SUCCESS') {
                    return;
                }

                audiobookCtrl.membersReviewList = response.reviewList;
                audiobookCtrl.myReview = response.myReview;
            };

            /*Init Book Date*/
            audiobookCtrl.initAudiobookDetails().then();
            audiobookCtrl.initAudiobookReviews().then();

            audiobookCtrl.playSample = function (audiobook) {
                $rootScope.$broadcast('playSample', audiobook);
            };

            audiobookCtrl.playAudiobook = function () {
                if (isMobile.any()) {
                    //show mobilePlayAlertModal
                    PlayerModel.audiobookPendingToPlay = audiobookCtrl.libraryAudiobook;
                    ModalsModel.open(
                        '/player/mobilePlayerAlert/mobilePlayerAlertModal.html',
                        'PlayerAlertCtrl',
                        'playerAlertCtrl',
                        'mobilePlayAlertModal');
                    return;
                }
                $rootScope.$broadcast('playAudiobook', audiobookCtrl.libraryAudiobook);
            };

            audiobookCtrl.addToWishList = async function (audiobook) {
                const response = await CatalogModel.addToWishList(audiobook);
                if (response != null && response.responseStatus == 'SUCCESS') {
                    audiobookCtrl.audiobook.wishListItemId = response.wishListItemId;
                }
            };

            audiobookCtrl.deleteFromWishList = async function (wishListItemId) {
                const response = await CatalogModel.deleteFromWishList(wishListItemId);
                if (response != null && response.responseStatus == 'SUCCESS') {
                    audiobookCtrl.audiobook.wishListItemId = null;
                }
            };

            audiobookCtrl.goToRateAndReview = function () {
                const scrollToPosition = $('#audiobookRateReviewAnchor').offset().top - 65;
                $("html,body").animate({scrollTop: scrollToPosition}, 300);
            };

            audiobookCtrl.editMyReview = function () {
                audiobookCtrl.editReview = true;
                var myReview = audiobookCtrl.myReview;
                audiobookCtrl.reviewHeadline = myReview.reviewHeadline;
                audiobookCtrl.reviewBody = myReview.reviewBody;
                audiobookCtrl.rating = myReview.rating;
            };

            //Review Audiobook

            $scope.$on('setRating', function (event, rating) {
                audiobookCtrl.rating = rating;
            });

            audiobookCtrl.deleteReview = async function () {
                const response = await ReviewModel.deleteReview(audiobookCtrl.myReview.id);
                if (response != null && response.responseStatus == 'SUCCESS') {
                    audiobookCtrl.myReview = null;
                    audiobookCtrl.discardReview();
                }
            };

            audiobookCtrl.reviewAudiobook = async () => {

                audiobookCtrl.reviewServerError = null;

                const response = await ReviewModel.reviewAudiobook(
                    audiobookCtrl.audiobook.id,
                    audiobookCtrl.rating,
                    audiobookCtrl.reviewHeadline,
                    audiobookCtrl.reviewBody);
                if (response != null && response.responseStatus === 'SUCCESS') {
                    const myReviewObj = {
                        audiobookId: audiobookCtrl.audiobook.id,
                        rating: audiobookCtrl.rating,
                        reviewHeadline: audiobookCtrl.reviewHeadline,
                        reviewBody: audiobookCtrl.reviewBody,
                        reviewId: response.reviewId,
                        updateDate: new Date().getTime(),
                        avatarUrl: AccountModel.userDetails.avatarUrl,
                        userDisplayName: AccountModel.userDetails.fullName
                    };
                    audiobookCtrl.myReview = myReviewObj;
                    audiobookCtrl.editReview = false;
                } else {
                    audiobookCtrl.reviewServerError = ReviewModel.getReviewAudiobookError(response);
                }
            };

            audiobookCtrl.discardReview = function () {
                audiobookCtrl.audiobookId = null;
                audiobookCtrl.rating = null;
                audiobookCtrl.reviewHeadline = null;
                audiobookCtrl.reviewBody = null;
                audiobookCtrl.editReview = false;
                $rootScope.$broadcast('resetRating');
            };

            audiobookCtrl.fbq = function () {
                fbq('track', 'AddToCart', {content_type: 'product', content_ids: [audiobookCtrl.audiobook.id]});
            };


        }])

    .filter('linkToAudiobook', ['$filter', function ($filter) {
        return function (audiobook, pointToRetailOffer) {
            if (!audiobook) {
                return null;
            }

            pointToRetailOffer = pointToRetailOffer ? true : audiobook.onSale;

            var finalLink = (pointToRetailOffer ? "/audiobookRetailOffer/" : "/audiobook/") + audiobook.id;
            if (audiobook.authorList) {
                var normalizedAuthorList = [];
                for (var i = 0; i < audiobook.authorList.length; i++) {
                    var author = audiobook.authorList[i];
                    normalizedAuthorList.push($filter('urlReadyName')(author.name));
                }
                var title = $filter('urlReadyName')(audiobook.title);

                var joinedAuthors = normalizedAuthorList.join("_");
                finalLink += "/" + joinedAuthors + "/" + title;
            }
            return finalLink;
        }
    }])

    .filter('urlReadyName', function () {
        return function (name) {
            if (name == null) {
                return "";
            }
            return name.trim().replace(/ /g, "-").replace(/[^A-Za-z0-9-]/g, "");
        }
    });

